import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class BannerVendorService {
    constructor(private http: HttpClient) { }

    getAll(params) {
        return this.http.get<any[]>(`${environment.apiUrl}/banner-vendor`, { params: params });
    }

    getPlan(id): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/banner-vendor/${id}`);
    }

}